<template>
  <div class="profile">
    <!-- Basic User Information -->
    <div class="user-profile bg-white rounded py-4 px-6" :class="[roleUserLogin !== 1 ? 'block' : 'hidden']">
      <p class="font-medium text-base mb-4">
        基本情報
      </p>
      <hr />
      <div class="mt-5 max-w-xl mx-auto">
          <el-form
            ref="authUser"
            :model="userProfile"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >

            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                  ユーザー名:
                </div>
                <div class="w-full">
                  <el-form-item prop="userName" class="mb-0 w-full ">
                    <el-input
                      v-model="userProfile.full_name"
                      name="userName"
                      type="text"
                      :placeholder="'ユーザー名'"
                      disabled
                    />
                  </el-form-item>
                </div>
              </div>

            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                ユーザーのメールアドレス:
                </div>
                <div class="w-full">
                  <el-form-item prop="email" class="mb-0 w-full ">
                    <el-input
                      v-model="userProfile.email"
                      name="email"
                      type="text"
                      :placeholder="'email'"
                      disabled
                    />
                  </el-form-item>
                </div>
              </div>

          </el-form>
      </div>
    </div>

    <!-- Basic infor organization Information -->
    <div class="user-profile bg-white rounded py-4 px-6" :class="[ roleUserLogin === 1 ? 'block' : 'hidden' ]">
      <p class="font-medium text-base mb-4">
        基本情報
      </p>
      <hr />
      <div class="mt-5 max-w-xl mx-auto">
          <el-form
            ref="authUser"
            :model="orgDetail"
            :rules="formRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >
              <div class="flex justify-between mt-4" :class="showTitleClass()">
                <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                  組織名:
                </div>
                <div class="w-full">
                  <el-form-item prop="name" class="mb-0 w-full ">
                    <el-input
                      v-model="orgDetail.name"
                      name="userName"
                      type="text"
                      disabled
                      :placeholder="'組織名'"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="flex justify-between mt-4" :class="showTitleClass()">
                <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                    アカウントID:
                </div>
                <div class="w-full">
                  <el-form-item prop="contact_email" class="mb-0 w-full">
                    <el-input
                      v-model="orgDetail.contact_email"
                      name="email"
                      type="text"
                      :placeholder="'アカウントID'"
                      disabled
                    />
                  </el-form-item>
                </div>
              </div>

            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                有効期限:
              </div>
              <div class="w-full">
                <el-input
                  v-model="expiredAt"
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                最大ユーザー数:
              </div>
              <div class="w-full">
                <el-input
                  v-model="amountLimit"
                  type="text"
                  :placeholder="'最大ユーザー数'"
                  disabled
                />
              </div>
            </div>
            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
              </div>
              <div class="w-full">
                <el-button
                    v-if="is_superuser"
                    :loading="loading"
                    class="mb-6 custom-btn-add"
                    :class="isMobile ? 'change-password' : ''"
                    style=" color: black; padding: 8px 20px;"
                    @click.native.prevent="handleChangeName()"
                >
                  <span class="font-normal text-base">{{ "更新" }}</span>
                </el-button>
              </div>
            </div>
          </el-form>
      </div>
    </div>

    <!-- Change Password -->
    <div class="user-profile bg-white rounded py-4 px-6 mt-6">
      <p class="font-medium text-base mb-4">
        パスワード変更
      </p>
      <hr />
      <div class="mt-5 max-w-xl mx-auto">
        <ValidationObserver v-slot="{ invalid }">
          <el-form
            ref="changePassword"
            :model="changePassword"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >
            <!-- Current password -->
            <ValidationProvider
              name="パスワードの長さは"
              :rules="{
                min: 8,
                max: 20,
              }"
              v-slot="{ errors }"
              class=""
            >
              <div class="flex justify-between mt-4" :class="showTitleClass()">
                <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                  現在のパスワード:
                </div>
                <div class="w-full">
                  <el-form-item prop="currentPassword" class="mb-0 w-full ">
                    <el-input
                      v-model.trim="changePassword.currentPassword"
                      name="パスワードの長さは"
                      type="password"
                      :placeholder="'現在のパスワード'"
                    />
                  </el-form-item>
                  <span class="text-red-500 ">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>
            <!-- New Password -->
            <ValidationProvider
              name="パスワードの長さは"
              :rules="{
                min: 8,
                max: 20
              }"
              v-slot="{ errors }"
              class=""
              vid="newPassword"
            >
              <div class="flex justify-between mt-4" :class="showTitleClass()">
                <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                  新しいパスワード:
                </div>
                <div class="w-full">
                  <el-form-item prop="newPassword" class="mb-0 w-full ">
                    <el-input
                      v-model.trim="changePassword.newPassword"
                      name="パスワードの長さは"
                      type="password"
                      :placeholder="'新しいパスワード'"
                    />
                  </el-form-item>
                  <span class="text-red-500 ">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <!-- New Password Confirm -->
            <ValidationProvider
              name="パスワードの長さは"
              :rules="{ confirmed: 'newPassword' }"
              v-slot="{ errors }"
              class=""
            >
              <div class="flex justify-between mt-4" :class="showTitleClass()">
                <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
                  新しいパスワード確認:
                </div>
                <div class="w-full">
                  <el-form-item prop="newPasswordConfirm" class="mb-0 w-full ">
                    <el-input
                      v-model.trim="changePassword.newPasswordConfirm"
                      name="newPasswordConfirm"
                      type="password"
                      :placeholder="'新しいパスワード確認'"
                    />
                  </el-form-item>
                  <span class="text-red-500 ">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <div class="flex justify-between mt-4" :class="showTitleClass()">
              <div class="leading-10 mr-6 whitespace-nowrap" :class="showInputClass()">
              </div>
              <div class="w-full">
                <el-button
                    class="mb-6 custom-btn-add"
                    :class="isMobile ? 'change-password' : ''"
                    style=" color: black; padding: 8px 20px;"
                    @click.native.prevent="handleChangePassword"
                    :disabled="invalid || form_null"
                >
                  <span class="font-normal text-base">{{ "更新" }}</span>
                </el-button>
              </div>
            </div>
          </el-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>

import moment from "moment";

const userDefaultLogo = require("@/assets/userdefault.png");
import fixHeightMain from "@/mixins/fixHeightMain.mixin";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { validEmail } from "@/utils/validate";

export default {
  mixins: [fixHeightMain],
  data: function() {
    return {
      changePassword: {
        currentPassword: "",
        newPassword: "",
        newPasswordConfirm: "",
      },
      userProfile: {
        full_name: "",
        email: "",
      },
      formRules: {
        name: [{required: true, message: '組織名を入力してください' , trigger: 'blur'}],
        contact_email: [{required: true, message: 'ユーザーのメールアドレスを入力してください' ,
          validator: (rule, value, callback) => {
            if (!validEmail(value)) {
              callback(new Error("有効なメールアドレスを入力してください。"));
            } else {
              callback();
            }
          } ,trigger: 'blur'}],
      },
      orgDetail: {
        name: '',
        email: '',
        amount_limit: 0,
        contact_email: ''
      },
      userDefaultLogo: userDefaultLogo,
      roleUserLogin: "",
      amountLimit: "",
      expiredAt: "",
      loading: false,
      is_superuser: false
    };
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.authUser,
      device: state => state.device.device
    }),
    formNullUserInfo() {
      return !this.userProfile.full_name || !this.userProfile.email;
    },
    isMobile() {
      return this.device === 'mobile'
    },
    form_null() {
      return (
        !this.changePassword.currentPassword ||
        !this.changePassword.newPassword ||
        !this.changePassword.newPasswordConfirm
      );
    },
  },
  methods: {
    ...mapActions("auth", ["getAuthUser", "changePasswordUser", "logOut"]),
    ...mapActions("admin_organizations", ["getDetail", 'update']),
    handleChangeName() {
      this.$refs.authUser.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const data = {
            id: this.orgDetail.id,
            name: this.orgDetail.name,
            contact_email: this.orgDetail.contact_email,
            expired_at: moment(this.orgDetail.expired_at).format('YYYY-MM-DD'),
            type: this.orgDetail.type
          }
          let res = await this.update(data);
          if (!res.success) {
            setTimeout(() => {
              this.$notify.error({
                title: "エラー",
                message: _.first(_.values(res.data.message)),
              });
            }, 500);
          } else {
            setTimeout(() => {
              this.$notify.success({
                title: "成功",
                message: '更新の成功',
              });
            }, 500);
          }
          this.loading = false
        }
      })
    },
    handleUpdateUserInfo() {
      const data = {
        full_name: this.userProfile.full_name,
        email: this.userProfile.email,
      };
      console.log("Call api update user info", data);
    },
    showTitleClass() {
      return this.isMobile ? 'flex-wrap' : ''
    },

    showInputClass() {
      return this.isMobile ? 'w-full text-left' : 'w-64 text-right'
    },

    async handleChangePassword() {
      const data = {
        old_password: this.changePassword.currentPassword,
        password: this.changePassword.newPassword,
        re_password: this.changePassword.newPasswordConfirm
      }
      let resPassword = await this.changePasswordUser(data);
      if (resPassword.success == true) {
        localStorage.removeItem('token');
        this.$router.push({
          name: 'login',
        })
      } else {
        setTimeout(() => {
          this.$notify.error({
            title: "エラー",
              message: _.first(_.values(resPassword.data)),
            });
        }, 500);
      }
    },
  },
  async created() {
    let userInfo = await this.getAuthUser();
    this.userProfile = _.cloneDeep(userInfo);
    this.roleUserLogin = this.authUser.role;
    this.is_superuser = this.authUser.is_superuser;
    const data = {
      id: this.authUser.org_id
    }
    let resDetail = await this.getDetail(data);
    this.amountLimit = resDetail.data.amount_limit;
    this.expiredAt = moment(resDetail.data.expired_at).format("YYYY-MM-DD HH:mm:ss");
    this.orgDetail = resDetail.data
  },
};
</script>
<style scoped>
.w-64 {
  width: 20rem;
}
.ml-48{
  margin-left: 13rem;
}
.custom-btn-add {
  width: 100px;
  text-align: center;
  padding: 6px 20px;
}
@media screen and (max-width: 768px) {
  .change-password {
    text-align: left;
    margin-left: 0;
  }
  .user-profile {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
